interface BracketSportHeadingProps {
  sportLabel: string
  /** 종목 옆에 붙는 보조 문구 (예: "체급 3개", "12경기") */
  description: string
  /** 화면마다 위에 놓인 제목 단계가 달라 받는다 */
  level: "h2" | "h3"
}

/**
 * 종목 묶음 제목.
 *
 * 경기 번호가 종목마다 1부터라 종목이 섞이면 같은 번호가 여러 번 나온다 —
 * 종목마다 이 제목을 달아 어느 종목의 「N경기」인지 한눈에 갈라 보이게 한다.
 */
export default function BracketSportHeading({
  sportLabel,
  description,
  level,
}: Readonly<BracketSportHeadingProps>) {
  const Heading = level

  return (
    <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 border-l-4 border-app-primary-500 pl-3">
      <Heading className="app-txt-h2">{sportLabel}</Heading>
      <span className="app-txt-body2 text-app-text-200">{description}</span>
    </div>
  )
}
